import { Button, Card, Form, Input, Modal } from "antd";
import { RegisterUserType, TUser } from "api/services/models/types";
import { changePassword } from "api/services/UserService";
import { AxiosError } from "axios";
import ErrorViewer from "components/ErrorViewer";
import { useState } from "react";
import { validatePassword } from "./validators";

type TChangeUserPasswordProps = {
  user: TUser;
  onClose: () => void;
};

type TFields = {
  password: string;
};

const ChangePassword = ({ user, onClose }: TChangeUserPasswordProps) => {
  const [form] = Form.useForm();
  const [error, setError] = useState<AxiosError | null>(null);

  const onFinish = (values: TFields) => {
    changePassword(user.ciamUserId, values.password).then(onClose).catch(setError);
  };

  return (
    <Modal
      width={444}
      maskClosable={false}
      open={true}
      footer={null}
      onCancel={() => onClose()}
      title={`Change password for User: ${user.userId}@${user.accountId}`}>
      {error && <ErrorViewer error={error} />}
        <Form
          form={form}
          name="register-user"
          onFinish={onFinish}
          layout="vertical"
          style={{ marginTop: "16px" }}>
          <Form.Item
            name={"password"}
            label={<label htmlFor="password" className="input-label">
              Password
              </label>}
            rules={[{ required: true }, validatePassword(RegisterUserType.IntenalUser)]}>
            <Input.Password  className="filter-input-transparent"/>
          </Form.Item>

          <Form.Item
            name={"confirmPassword"}
            label={<label htmlFor="confirmPassword" className="input-label">
              Confirm Password
              </label>}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value, callback) {
                  if (!value || getFieldValue("password") === value) {
                    callback();
                  }
                  callback("The new password that you entered do not match!");
                }
              })
            ]}>
            <Input.Password  className="filter-input-transparent"/>
          </Form.Item>

          <Form.Item label={null} style={{ textAlign: "right" }}>
            <Button type="primary" htmlType="submit">
              Change Password
            </Button>
          </Form.Item>
        </Form>
    </Modal>
  );
};

export default ChangePassword;
